export const ALL_WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;

export const WEEKDAY_OPTIONS = [
  { value: 1, short: "월", label: "월요일" },
  { value: 2, short: "화", label: "화요일" },
  { value: 3, short: "수", label: "수요일" },
  { value: 4, short: "목", label: "목요일" },
  { value: 5, short: "금", label: "금요일" },
  { value: 6, short: "토", label: "토요일" },
  { value: 0, short: "일", label: "일요일" },
] as const;

export function normalizeAvailableDays(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  return [...new Set(value)]
    .filter(
      (day): day is number =>
        typeof day === "number" && Number.isInteger(day) && day >= 0 && day <= 6,
    )
    .sort((a, b) => a - b);
}

export function parseAvailableDays(value: unknown): number[] {
  if (Array.isArray(value)) {
    const parsed = normalizeAvailableDays(value);
    return parsed.length ? parsed : [...ALL_WEEKDAYS];
  }
  if (typeof value === "string") {
    const parsed = normalizeAvailableDays(
      value.split(",").map((day) => Number(day.trim())),
    );
    return parsed.length ? parsed : [...ALL_WEEKDAYS];
  }
  return [...ALL_WEEKDAYS];
}

export function menuAvailableOnDate(
  availableDays: number[] | undefined,
  date: string,
) {
  return parseAvailableDays(availableDays).includes(
    new Date(`${date}T00:00:00Z`).getUTCDay(),
  );
}

export function menuAvailableForDates(
  availableDays: number[] | undefined,
  dates: string[],
) {
  return dates.every((date) => menuAvailableOnDate(availableDays, date));
}

export function availableDaysLabel(availableDays: number[] | undefined) {
  const days = parseAvailableDays(availableDays);
  if (days.length === ALL_WEEKDAYS.length) return "요일 제한 없음";
  return WEEKDAY_OPTIONS.filter((option) => days.includes(option.value))
    .map((option) => option.short)
    .join("·");
}
